"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var n,
    r = require("react"),
    t = (n = require("classnames")) && "object" == typeof n && "default" in n ? n.default : n,
    a = require("@emotion/core"),
    e = require("react-is"),
    o = require("react-intersection-observer");

function s() {
  return (s = Object.assign || function (n) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var a in t) {
        Object.prototype.hasOwnProperty.call(t, a) && (n[a] = t[a]);
      }
    }

    return n;
  }).apply(this, arguments);
}

function i(n, r) {
  if (null == n) return {};
  var t,
      a,
      e = {},
      o = Object.keys(n);

  for (a = 0; a < o.length; a++) {
    r.indexOf(t = o[a]) >= 0 || (e[t] = n[t]);
  }

  return e;
}

function f(n, r) {
  return r || (r = n.slice(0)), n.raw = r, n;
}

function c() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return c = function c() {
    return n;
  }, n;
}

var u = a.keyframes(c());

function m() {
  var n = f(["\n    animation-duration: ", "ms;\n    animation-timing-function: ", ";\n    animation-delay: ", "ms;\n    animation-name: ", ";\n    animation-direction: normal;\n    animation-fill-mode: both;\n    animation-iteration-count: ", ";\n  "]);
  return m = function m() {
    return n;
  }, n;
}

function d(n) {
  var r = n.duration,
      t = void 0 === r ? 1e3 : r,
      e = n.delay,
      o = void 0 === e ? 0 : e,
      s = n.timingFunction,
      i = void 0 === s ? "ease" : s,
      f = n.keyframes,
      c = void 0 === f ? u : f,
      d = n.iterationCount,
      l = void 0 === d ? 1 : d;
  return a.css(m(), t, i, o, c, l);
}

var l = function l(n) {
  var i = n.cascade,
      f = void 0 !== i && i,
      c = n.damping,
      m = void 0 === c ? .5 : c,
      l = n.delay,
      p = void 0 === l ? 0 : l,
      y = n.duration,
      v = void 0 === y ? 1e3 : y,
      g = n.fraction,
      k = void 0 === g ? 0 : g,
      x = n.keyframes,
      b = void 0 === x ? u : x,
      h = n.triggerOnce,
      w = void 0 !== h && h,
      O = n.css,
      Y = n.className,
      j = n.style,
      X = n.childClassName,
      z = n.childStyle;
  return a.jsx(r.Fragment, null, function n(i) {
    return i ? "string" == typeof i ? (c = i, u = {
      display: "inline-block",
      whiteSpace: "pre"
    }, a.jsx(o.InView, {
      threshold: k,
      triggerOnce: w
    }, function (n) {
      var r = n.inView;
      return a.jsx("div", {
        ref: n.ref,
        css: [O, u],
        className: Y,
        style: j
      }, c.split("").map(function (n, t) {
        var e = r ? d({
          keyframes: b,
          delay: p + (f ? t * v * m : 0),
          duration: v
        }) : {
          opacity: 0
        };
        return a.jsx("span", {
          key: t,
          css: e,
          className: X,
          style: z
        }, n);
      }));
    })) : e.isFragment(i) ? a.jsx(o.InView, {
      threshold: k,
      triggerOnce: w
    }, function (n) {
      return a.jsx("div", {
        ref: n.ref,
        css: n.inView ? [O, d({
          keyframes: b,
          delay: p,
          duration: v
        })] : {
          opacity: 0
        },
        className: Y,
        style: j
      }, i);
    }) : r.Children.map(i, function (e, i) {
      var c = e,
          u = c.props.css ? [c.props.css] : [];

      switch (u.push(d({
        keyframes: b,
        delay: p + (f ? i * v * m : 0),
        duration: v
      })), c.type) {
        case "ol":
        case "ul":
          return r.cloneElement(c, {
            className: t(Y, c.props.className),
            style: s({}, j, c.props.style)
          }, n(c.props.children));

        case "li":
          return a.jsx(o.InView, {
            threshold: k,
            triggerOnce: w
          }, function (n) {
            return a.jsx(c.type, s({}, c.props, {
              ref: n.ref,
              css: n.inView ? [O].concat(u) : {
                opacity: 0
              },
              className: t(X, c.props.className),
              style: s({}, z, c.props.style)
            }));
          });

        default:
          return a.jsx(o.InView, {
            threshold: k,
            triggerOnce: w
          }, function (n) {
            return a.jsx("div", {
              ref: n.ref,
              css: n.inView ? [O].concat(u) : {
                opacity: 0
              },
              className: Y,
              style: j
            }, r.cloneElement(c, {
              className: t(X, c.props.className),
              style: s({}, z, c.props.style)
            }));
          });
      }
    }) : null;
    var c, u;
  }(n.children));
};

function p() {
  var n = f(["\n  from,\n  20%,\n  53%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, 0, 0);\n  }\n\n  40%,\n  43% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -30px, 0) scaleY(1.1);\n  }\n\n  70% {\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n    transform: translate3d(0, -15px, 0) scaleY(1.05);\n  }\n\n  80% {\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate3d(0, 0, 0) scaleY(0.95);\n  }\n\n  90% {\n    transform: translate3d(0, -4px, 0) scaleY(1.02);\n  }\n"]);
  return p = function p() {
    return n;
  }, n;
}

var y = a.keyframes(p());

function v() {
  var n = f(["\n  from,\n  50%,\n  to {\n    opacity: 1;\n  }\n\n  25%,\n  75% {\n    opacity: 0;\n  }\n"]);
  return v = function v() {
    return n;
  }, n;
}

var g = a.keyframes(v());

function k() {
  var n = f(["\n  0% {\n    transform: translateX(0);\n  }\n\n  6.5% {\n    transform: translateX(-6px) rotateY(-9deg);\n  }\n\n  18.5% {\n    transform: translateX(5px) rotateY(7deg);\n  }\n\n  31.5% {\n    transform: translateX(-3px) rotateY(-5deg);\n  }\n\n  43.5% {\n    transform: translateX(2px) rotateY(3deg);\n  }\n\n  50% {\n    transform: translateX(0);\n  }\n"]);
  return k = function k() {
    return n;
  }, n;
}

var x = a.keyframes(k());

function b() {
  var n = f(["\n  0% {\n    transform: scale(1);\n  }\n\n  14% {\n    transform: scale(1.3);\n  }\n\n  28% {\n    transform: scale(1);\n  }\n\n  42% {\n    transform: scale(1.3);\n  }\n\n  70% {\n    transform: scale(1);\n  }\n"]);
  return b = function b() {
    return n;
  }, n;
}

var h = a.keyframes(b());

function w() {
  var n = f(["\n  from,\n  11.1%,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  22.2% {\n    transform: skewX(-12.5deg) skewY(-12.5deg);\n  }\n\n  33.3% {\n    transform: skewX(6.25deg) skewY(6.25deg);\n  }\n\n  44.4% {\n    transform: skewX(-3.125deg) skewY(-3.125deg);\n  }\n\n  55.5% {\n    transform: skewX(1.5625deg) skewY(1.5625deg);\n  }\n\n  66.6% {\n    transform: skewX(-0.78125deg) skewY(-0.78125deg);\n  }\n\n  77.7% {\n    transform: skewX(0.390625deg) skewY(0.390625deg);\n  }\n\n  88.8% {\n    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);\n  }\n"]);
  return w = function w() {
    return n;
  }, n;
}

var O = a.keyframes(w());

function Y() {
  var n = f(["\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  50% {\n    transform: scale3d(1.05, 1.05, 1.05);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n"]);
  return Y = function Y() {
    return n;
  }, n;
}

var j = a.keyframes(Y());

function X() {
  var n = f(["\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  30% {\n    transform: scale3d(1.25, 0.75, 1);\n  }\n\n  40% {\n    transform: scale3d(0.75, 1.25, 1);\n  }\n\n  50% {\n    transform: scale3d(1.15, 0.85, 1);\n  }\n\n  65% {\n    transform: scale3d(0.95, 1.05, 1);\n  }\n\n  75% {\n    transform: scale3d(1.05, 0.95, 1);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n"]);
  return X = function X() {
    return n;
  }, n;
}

var z = a.keyframes(X());

function E() {
  var n = f(["\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translate3d(10px, 0, 0);\n  }\n"]);
  return E = function E() {
    return n;
  }, n;
}

var N = a.keyframes(E());

function V() {
  var n = f(["\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translate3d(10px, 0, 0);\n  }\n"]);
  return V = function V() {
    return n;
  }, n;
}

var F = a.keyframes(V());

function q() {
  var n = f(["\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%,\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: translate3d(0, -10px, 0);\n  }\n\n  20%,\n  40%,\n  60%,\n  80% {\n    transform: translate3d(0, 10px, 0);\n  }\n"]);
  return q = function q() {
    return n;
  }, n;
}

var I = a.keyframes(q());

function S() {
  var n = f(["\n  20% {\n    transform: rotate3d(0, 0, 1, 15deg);\n  }\n\n  40% {\n    transform: rotate3d(0, 0, 1, -10deg);\n  }\n\n  60% {\n    transform: rotate3d(0, 0, 1, 5deg);\n  }\n\n  80% {\n    transform: rotate3d(0, 0, 1, -5deg);\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n"]);
  return S = function S() {
    return n;
  }, n;
}

var B = a.keyframes(S());

function T() {
  var n = f(["\n  from {\n    transform: scale3d(1, 1, 1);\n  }\n\n  10%,\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);\n  }\n\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);\n  }\n\n  40%,\n  60%,\n  80% {\n    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);\n  }\n\n  to {\n    transform: scale3d(1, 1, 1);\n  }\n"]);
  return T = function T() {
    return n;
  }, n;
}

var C = a.keyframes(T());

function P() {
  var n = f(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  15% {\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n  }\n\n  30% {\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n  }\n\n  45% {\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n  }\n\n  60% {\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n  }\n\n  75% {\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return P = function P() {
    return n;
  }, n;
}

var R = a.keyframes(P());

function _() {
  var n = f(["\n  from,\n  20%,\n  40%,\n  60%,\n  80%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  20% {\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  40% {\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(1.03, 1.03, 1.03);\n  }\n\n  80% {\n    transform: scale3d(0.97, 0.97, 0.97);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n  }\n"]);
  return _ = function _() {
    return n;
  }, n;
}

var A = a.keyframes(_());

function H() {
  var n = f(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0) scaleY(3);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0) scaleY(0.9);\n  }\n\n  75% {\n    transform: translate3d(0, -10px, 0) scaleY(0.95);\n  }\n\n  90% {\n    transform: translate3d(0, 5px, 0) scaleY(0.985);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return H = function H() {
    return n;
  }, n;
}

var J = a.keyframes(H());

function M() {
  var n = f(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0) scaleX(3);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0) scaleX(1);\n  }\n\n  75% {\n    transform: translate3d(-10px, 0, 0) scaleX(0.98);\n  }\n\n  90% {\n    transform: translate3d(5px, 0, 0) scaleX(0.995);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return M = function M() {
    return n;
  }, n;
}

var Z = a.keyframes(M());

function D() {
  var n = f(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0) scaleX(3);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0) scaleX(1);\n  }\n\n  75% {\n    transform: translate3d(10px, 0, 0) scaleX(0.98);\n  }\n\n  90% {\n    transform: translate3d(-5px, 0, 0) scaleX(0.995);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return D = function D() {
    return n;
  }, n;
}

var G = a.keyframes(D());

function K() {
  var n = f(["\n  from,\n  60%,\n  75%,\n  90%,\n  to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0) scaleY(5);\n  }\n\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0) scaleY(0.9);\n  }\n\n  75% {\n    transform: translate3d(0, 10px, 0) scaleY(0.95);\n  }\n\n  90% {\n    transform: translate3d(0, -5px, 0) scaleY(0.985);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return K = function K() {
    return n;
  }, n;
}

var L = a.keyframes(K());

function Q() {
  var n = f(["\n  20% {\n    transform: scale3d(0.9, 0.9, 0.9);\n  }\n\n  50%,\n  55% {\n    opacity: 1;\n    transform: scale3d(1.1, 1.1, 1.1);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n"]);
  return Q = function Q() {
    return n;
  }, n;
}

var U = a.keyframes(Q());

function W() {
  var n = f(["\n  20% {\n    transform: translate3d(0, 10px, 0) scaleY(0.985);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0) scaleY(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0) scaleY(3);\n  }\n"]);
  return W = function W() {
    return n;
  }, n;
}

var $ = a.keyframes(W());

function nn() {
  var n = f(["\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0) scaleX(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0) scaleX(2);\n  }\n"]);
  return nn = function nn() {
    return n;
  }, n;
}

var rn = a.keyframes(nn());

function tn() {
  var n = f(["\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0) scaleX(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0) scaleX(2);\n  }\n"]);
  return tn = function tn() {
    return n;
  }, n;
}

var an = a.keyframes(tn());

function en() {
  var n = f(["\n  20% {\n    transform: translate3d(0, -10px, 0) scaleY(0.985);\n  }\n\n  40%,\n  45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0) scaleY(0.9);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0) scaleY(3);\n  }\n"]);
  return en = function en() {
    return n;
  }, n;
}

var on = a.keyframes(en());

function sn(n, r) {
  switch (r) {
    case "down":
      return n ? $ : J;

    case "left":
      return n ? rn : Z;

    case "right":
      return n ? an : G;

    case "up":
      return n ? on : L;

    default:
      return n ? U : A;
  }
}

function fn() {
  var n = f(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"]);
  return fn = function fn() {
    return n;
  }, n;
}

var cn = a.keyframes(fn());

function un() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return un = function un() {
    return n;
  }, n;
}

var mn = a.keyframes(un());

function dn() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(100%, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return dn = function dn() {
    return n;
  }, n;
}

var ln = a.keyframes(dn());

function pn() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return pn = function pn() {
    return n;
  }, n;
}

var yn = a.keyframes(pn());

function vn() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return vn = function vn() {
    return n;
  }, n;
}

var gn = a.keyframes(vn());

function kn() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return kn = function kn() {
    return n;
  }, n;
}

var xn = a.keyframes(kn());

function bn() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return bn = function bn() {
    return n;
  }, n;
}

var hn = a.keyframes(bn());

function wn() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return wn = function wn() {
    return n;
  }, n;
}

var On = a.keyframes(wn());

function Yn() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return Yn = function Yn() {
    return n;
  }, n;
}

var jn = a.keyframes(Yn());

function Xn() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(100%, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return Xn = function Xn() {
    return n;
  }, n;
}

var zn = a.keyframes(Xn());

function En() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return En = function En() {
    return n;
  }, n;
}

var Nn = a.keyframes(En());

function Vn() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return Vn = function Vn() {
    return n;
  }, n;
}

var Fn = a.keyframes(Vn());

function qn() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"]);
  return qn = function qn() {
    return n;
  }, n;
}

var In = a.keyframes(qn());

function Sn() {
  var n = f(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 100%, 0);\n  }\n"]);
  return Sn = function Sn() {
    return n;
  }, n;
}

var Bn = a.keyframes(Sn());

function Tn() {
  var n = f(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 100%, 0);\n  }\n"]);
  return Tn = function Tn() {
    return n;
  }, n;
}

var Cn = a.keyframes(Tn());

function Pn() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n"]);
  return Pn = function Pn() {
    return n;
  }, n;
}

var Rn = a.keyframes(Pn());

function _n() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n"]);
  return _n = function _n() {
    return n;
  }, n;
}

var An = a.keyframes(_n());

function Hn() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n"]);
  return Hn = function Hn() {
    return n;
  }, n;
}

var Jn = a.keyframes(Hn());

function Mn() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n"]);
  return Mn = function Mn() {
    return n;
  }, n;
}

var Zn = a.keyframes(Mn());

function Dn() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0);\n  }\n"]);
  return Dn = function Dn() {
    return n;
  }, n;
}

var Gn = a.keyframes(Dn());

function Kn() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n"]);
  return Kn = function Kn() {
    return n;
  }, n;
}

var Ln = a.keyframes(Kn());

function Qn() {
  var n = f(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(-100%, -100%, 0);\n  }\n"]);
  return Qn = function Qn() {
    return n;
  }, n;
}

var Un = a.keyframes(Qn());

function Wn() {
  var n = f(["\n  from {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, -100%, 0);\n  }\n"]);
  return Wn = function Wn() {
    return n;
  }, n;
}

var $n = a.keyframes(Wn());

function nr() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n"]);
  return nr = function nr() {
    return n;
  }, n;
}

var rr = a.keyframes(nr());

function tr() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n"]);
  return tr = function tr() {
    return n;
  }, n;
}

var ar = a.keyframes(tr());

function er(n, r, t) {
  switch (t) {
    case "bottom-left":
      return r ? Bn : mn;

    case "bottom-right":
      return r ? Cn : ln;

    case "down":
      return n ? r ? An : gn : r ? Rn : yn;

    case "left":
      return n ? r ? Zn : xn : r ? Jn : u;

    case "right":
      return n ? r ? Ln : On : r ? Gn : hn;

    case "top-left":
      return r ? Un : jn;

    case "top-right":
      return r ? $n : zn;

    case "up":
      return n ? r ? ar : Fn : r ? rr : Nn;

    default:
      return r ? In : cn;
  }
}

function or() {
  var n = f(["\n  from {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);\n    animation-timing-function: ease-out;\n  }\n\n  40% {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)\n      rotate3d(0, 1, 0, -190deg);\n    animation-timing-function: ease-out;\n  }\n\n  50% {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)\n      rotate3d(0, 1, 0, -170deg);\n    animation-timing-function: ease-in;\n  }\n\n  80% {\n    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0)\n      rotate3d(0, 1, 0, 0deg);\n    animation-timing-function: ease-in;\n  }\n\n  to {\n    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);\n    animation-timing-function: ease-in;\n  }\n"]);
  return or = function or() {
    return n;
  }, n;
}

var sr = a.keyframes(or());

function ir() {
  var n = f(["\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1;\n  }\n\n  80% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n  }\n\n  to {\n    transform: perspective(400px);\n  }\n"]);
  return ir = function ir() {
    return n;
  }, n;
}

var fr = a.keyframes(ir());

function cr() {
  var n = f(["\n  from {\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n\n  40% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n\n  60% {\n    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);\n    opacity: 1;\n  }\n\n  80% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -5deg);\n  }\n\n  to {\n    transform: perspective(400px);\n  }\n"]);
  return cr = function cr() {
    return n;
  }, n;
}

var ur = a.keyframes(cr());

function mr() {
  var n = f(["\n  from {\n    transform: perspective(400px);\n  }\n\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n"]);
  return mr = function mr() {
    return n;
  }, n;
}

var dr = a.keyframes(mr());

function lr() {
  var n = f(["\n  from {\n    transform: perspective(400px);\n  }\n\n  30% {\n    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);\n    opacity: 1;\n  }\n\n  to {\n    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);\n    opacity: 0;\n  }\n"]);
  return lr = function lr() {
    return n;
  }, n;
}

var pr = a.keyframes(lr());

function yr(n, r) {
  switch (r) {
    case "horizontal":
      return n ? dr : fr;

    case "vertical":
      return n ? pr : ur;

    default:
      return sr;
  }
}

function vr() {
  var n = f(["\n  0% {\n    animation-timing-function: ease-in-out;\n  }\n\n  20%,\n  60% {\n    transform: rotate3d(0, 0, 1, 80deg);\n    animation-timing-function: ease-in-out;\n  }\n\n  40%,\n  80% {\n    transform: rotate3d(0, 0, 1, 60deg);\n    animation-timing-function: ease-in-out;\n    opacity: 1;\n  }\n\n  to {\n    transform: translate3d(0, 700px, 0);\n    opacity: 0;\n  }\n"]);
  return vr = function vr() {
    return n;
  }, n;
}

var gr = a.keyframes(vr());

function kr() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: scale(0.1) rotate(30deg);\n    transform-origin: center bottom;\n  }\n\n  50% {\n    transform: rotate(-10deg);\n  }\n\n  70% {\n    transform: rotate(3deg);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"]);
  return kr = function kr() {
    return n;
  }, n;
}

var xr = a.keyframes(kr());

function br() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return br = function br() {
    return n;
  }, n;
}

var hr = a.keyframes(br());

function wr() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);\n  }\n"]);
  return wr = function wr() {
    return n;
  }, n;
}

var Or = a.keyframes(wr());

function Yr(n) {
  return n ? Or : hr;
}

function jr() {
  var n = f(["\n  from {\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"]);
  return jr = function jr() {
    return n;
  }, n;
}

var Xr = a.keyframes(jr());

function zr() {
  var n = f(["\n  from {\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"]);
  return zr = function zr() {
    return n;
  }, n;
}

var Er = a.keyframes(zr());

function Nr() {
  var n = f(["\n  from {\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"]);
  return Nr = function Nr() {
    return n;
  }, n;
}

var Vr = a.keyframes(Nr());

function Fr() {
  var n = f(["\n  from {\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"]);
  return Fr = function Fr() {
    return n;
  }, n;
}

var qr = a.keyframes(Fr());

function Ir() {
  var n = f(["\n  from {\n    transform: rotate3d(0, 0, 1, -90deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n"]);
  return Ir = function Ir() {
    return n;
  }, n;
}

var Sr = a.keyframes(Ir());

function Br() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 200deg);\n    opacity: 0;\n  }\n"]);
  return Br = function Br() {
    return n;
  }, n;
}

var Tr = a.keyframes(Br());

function Cr() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 45deg);\n    opacity: 0;\n  }\n"]);
  return Cr = function Cr() {
    return n;
  }, n;
}

var Pr = a.keyframes(Cr());

function Rr() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n"]);
  return Rr = function Rr() {
    return n;
  }, n;
}

var _r = a.keyframes(Rr());

function Ar() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, -45deg);\n    opacity: 0;\n  }\n"]);
  return Ar = function Ar() {
    return n;
  }, n;
}

var Hr = a.keyframes(Ar());

function Jr() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    transform: rotate3d(0, 0, 1, 90deg);\n    opacity: 0;\n  }\n"]);
  return Jr = function Jr() {
    return n;
  }, n;
}

var Mr = a.keyframes(Jr());

function Zr() {
  var n = f(["\n  from {\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return Zr = function Zr() {
    return n;
  }, n;
}

var Dr = a.keyframes(Zr());

function Gr() {
  var n = f(["\n  from {\n    transform: translate3d(-100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return Gr = function Gr() {
    return n;
  }, n;
}

var Kr = a.keyframes(Gr());

function Lr() {
  var n = f(["\n  from {\n    transform: translate3d(100%, 0, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return Lr = function Lr() {
    return n;
  }, n;
}

var Qr = a.keyframes(Lr());

function Ur() {
  var n = f(["\n  from {\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n"]);
  return Ur = function Ur() {
    return n;
  }, n;
}

var Wr = a.keyframes(Ur());

function $r() {
  var n = f(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 100%, 0);\n  }\n"]);
  return $r = function $r() {
    return n;
  }, n;
}

var nt = a.keyframes($r());

function rt() {
  var n = f(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(-100%, 0, 0);\n  }\n"]);
  return rt = function rt() {
    return n;
  }, n;
}

var tt = a.keyframes(rt());

function at() {
  var n = f(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(100%, 0, 0);\n  }\n"]);
  return at = function at() {
    return n;
  }, n;
}

var et = a.keyframes(at());

function ot() {
  var n = f(["\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -100%, 0);\n  }\n"]);
  return ot = function ot() {
    return n;
  }, n;
}

var st = a.keyframes(ot());

function it(n, r) {
  switch (r) {
    case "down":
      return n ? nt : Dr;

    case "right":
      return n ? et : Qr;

    case "up":
      return n ? st : Wr;

    case "left":
    default:
      return n ? tt : Kr;
  }
}

function ft() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  50% {\n    opacity: 1;\n  }\n"]);
  return ft = function ft() {
    return n;
  }, n;
}

var ct = a.keyframes(ft());

function ut() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"]);
  return ut = function ut() {
    return n;
  }, n;
}

var mt = a.keyframes(ut());

function dt() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"]);
  return dt = function dt() {
    return n;
  }, n;
}

var lt = a.keyframes(dt());

function pt() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"]);
  return pt = function pt() {
    return n;
  }, n;
}

var yt = a.keyframes(pt());

function vt() {
  var n = f(["\n  from {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  60% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"]);
  return vt = function vt() {
    return n;
  }, n;
}

var gt = a.keyframes(vt());

function kt() {
  var n = f(["\n  from {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  to {\n    opacity: 0;\n  }\n"]);
  return kt = function kt() {
    return n;
  }, n;
}

var xt = a.keyframes(kt());

function bt() {
  var n = f(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"]);
  return bt = function bt() {
    return n;
  }, n;
}

var ht = a.keyframes(bt());

function wt() {
  var n = f(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0.1) translate3d(-2000px, 0, 0);\n  }\n"]);
  return wt = function wt() {
    return n;
  }, n;
}

var Ot = a.keyframes(wt());

function Yt() {
  var n = f(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0.1) translate3d(2000px, 0, 0);\n  }\n"]);
  return Yt = function Yt() {
    return n;
  }, n;
}

var jt = a.keyframes(Yt());

function Xt() {
  var n = f(["\n  40% {\n    opacity: 1;\n    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);\n    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  }\n\n  to {\n    opacity: 0;\n    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);\n    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);\n  }\n"]);
  return Xt = function Xt() {
    return n;
  }, n;
}

var zt = a.keyframes(Xt());

function Et(n, r) {
  switch (r) {
    case "down":
      return n ? ht : mt;

    case "left":
      return n ? Ot : lt;

    case "right":
      return n ? jt : yt;

    case "up":
      return n ? zt : gt;

    default:
      return n ? xt : ct;
  }
}

exports.AttentionSeeker = function (n) {
  var t = n.effect,
      a = void 0 === t ? "bounce" : t,
      e = n.css,
      o = i(n, ["effect", "css"]),
      s = function (n) {
    switch (n) {
      case "flash":
        return [g];

      case "headShake":
        return [x, {
          animationTimingFunction: "ease-in-out"
        }];

      case "heartBeat":
        return [h, {
          animationTimingFunction: "ease-in-out"
        }];

      case "jello":
        return [O, {
          transformOrigin: "center"
        }];

      case "pulse":
        return [j, {
          animationTimingFunction: "ease-in-out"
        }];

      case "rubberBand":
        return [z];

      case "shake":
        return [N];

      case "shakeX":
        return [F];

      case "shakeY":
        return [I];

      case "swing":
        return [B, {
          transformOrigin: "top center"
        }];

      case "tada":
        return [C];

      case "wobble":
        return [R];

      case "bounce":
      default:
        return [y, {
          transformOrigin: "center bottom"
        }];
    }
  }(a);

  return r.createElement(l, Object.assign({
    keyframes: s[0],
    css: [e, s[1]]
  }, o));
}, exports.Bounce = function (n) {
  var t = n.direction,
      a = n.reverse,
      e = void 0 !== a && a,
      o = i(n, ["direction", "reverse"]);
  return r.createElement(l, Object.assign({
    keyframes: sn(e, t)
  }, o));
}, exports.Fade = function (n) {
  var t = n.big,
      a = void 0 !== t && t,
      e = n.direction,
      o = n.reverse,
      s = void 0 !== o && o,
      f = i(n, ["big", "direction", "reverse"]);
  return r.createElement(l, Object.assign({
    keyframes: er(a, s, e)
  }, f));
}, exports.Flip = function (n) {
  var t = n.direction,
      a = n.reverse,
      e = void 0 !== a && a,
      o = n.css,
      s = i(n, ["direction", "reverse", "css"]);
  return r.createElement(l, Object.assign({
    keyframes: yr(e, t),
    css: [o, {
      backfaceVisibility: "visible"
    }]
  }, s));
}, exports.Hinge = function (n) {
  var t = n.css,
      a = i(n, ["css"]);
  return r.createElement(l, Object.assign({
    keyframes: gr,
    css: [t, {
      transformOrigin: "top left"
    }]
  }, a));
}, exports.JackInTheBox = function (n) {
  return r.createElement(l, Object.assign({
    keyframes: xr
  }, n));
}, exports.Roll = function (n) {
  var t = n.reverse,
      a = void 0 !== t && t,
      e = i(n, ["reverse"]);
  return r.createElement(l, Object.assign({
    keyframes: Yr(a)
  }, e));
}, exports.Rotate = function (n) {
  var t = n.direction,
      a = n.reverse,
      e = void 0 !== a && a,
      o = n.css,
      s = i(n, ["direction", "reverse", "css"]),
      f = function (n, r) {
    switch (r) {
      case "bottom-left":
        return n ? [Pr, {
          transformOrigin: "left bottom"
        }] : [Er, {
          transformOrigin: "left bottom"
        }];

      case "bottom-right":
        return n ? [_r, {
          transformOrigin: "right bottom"
        }] : [Vr, {
          transformOrigin: "right bottom"
        }];

      case "top-left":
        return n ? [Hr, {
          transformOrigin: "left bottom"
        }] : [qr, {
          transformOrigin: "left bottom"
        }];

      case "top-right":
        return n ? [Mr, {
          transformOrigin: "right bottom"
        }] : [Sr, {
          transformOrigin: "right bottom"
        }];

      default:
        return n ? [Tr, {
          transformOrigin: "center"
        }] : [Xr, {
          transformOrigin: "center"
        }];
    }
  }(e, t);

  return r.createElement(l, Object.assign({
    keyframes: f[0],
    css: [o, f[1]]
  }, s));
}, exports.Slide = function (n) {
  var t = n.direction,
      a = n.reverse,
      e = void 0 !== a && a,
      o = i(n, ["direction", "reverse"]);
  return r.createElement(l, Object.assign({
    keyframes: it(e, t)
  }, o));
}, exports.Zoom = function (n) {
  var t = n.direction,
      a = n.reverse,
      e = void 0 !== a && a,
      o = i(n, ["direction", "reverse"]);
  return r.createElement(l, Object.assign({
    keyframes: Et(e, t)
  }, o));
}, exports.default = l;